class TH_Timer {
    constructor(callback, delay) {
        this.timerId = null;
        this.start = null;
        this.remaining = delay;
        this.callback = callback;

        this.resume();
    }

    pause() {
        window.clearTimeout(this.timerId);
        this.remaining -= Date.now() - this.start;
    }

    resume() {
        this.start = Date.now();
        if (this.timerId !== null) window.clearTimeout(this.timerId);
        this.timerId = window.setTimeout(this.callback, this.remaining);
    }
}

export default TH_Timer;